import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import update from "immutability-helper";
import { PropertyGPS } from "../typeDefs/properties";
import { QueueMessage2 } from "../typeDefs/queueManagement";

export interface PropertiesState {
    propertyGps: PropertyGPS[];
    propertyGpsMessages: QueueMessage2[];
    loading: boolean;
}

const initialState: PropertiesState = {
    propertyGps: [],
    propertyGpsMessages: [],
    loading: false,
};

export const propertiesSlice = createSlice({
    name: "properties",
    initialState,
    reducers: {
        setPropertyGps: (state, action: PayloadAction<PropertyGPS[]>) => {
            state.propertyGps = action.payload;
        },
        setPropertyGpsMessages: (
            state,
            action: PayloadAction<QueueMessage2[]>
        ) => {
            state.propertyGpsMessages = action.payload;
        },
        updatePropertyGps: (state, action: PayloadAction<PropertyGPS>) => {
            const index = state.propertyGps.findIndex(
                (p) => p.PropertyId === action.payload.PropertyId
            );
            state.propertyGps = update(state.propertyGps, {
                $set: { [index]: action.payload },
            });
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
    },
});

export const {
    setPropertyGps,
    setPropertyGpsMessages,
    updatePropertyGps,
    setLoading,
} = propertiesSlice.actions;

export default propertiesSlice.reducer;
